import { ofType } from "redux-observable";
import { merge } from "rxjs";
import { combineChecks } from "../../../guards/combineChecks";
import { guard } from "../../../guards/guard";
import { invert } from "../../../guards/invert";
import { pathEmpty } from "../../../guards/pathEmpty";
import { TypeActionShowMe } from "../../actionShowMe";
import { checkAnyDecorationConstructionDoneAvailable } from "../../checks/checkAnyDecorationConstructionDoneAvailable";
import { checkAnyDecorationConstructionInProgressAvailable } from "../../checks/checkAnyDecorationConstructionInProgressAvailable";
import { pathFocusDecorationBuildingMaxLevel } from "../../path/pathFocusDecorationBuildingMaxLevel";
import { pathSelectBuildingConstructionInProgress } from "../../path/pathSelectBuildingConstructionInProgress";
import { pathSelectDecorationTabInBuildMenu } from "../../path/pathSelectDecorationTabInBuildMenu";
import { checkBuildingAvailableWithLessThanRequiredLevel } from "./checks/checkBuildingAvailableWithLessThanRequiredLevel";
import { checkBuildingConstructionDoneAvailable } from "./checks/checkBuildingConstructionDoneAvailable";
import { checkBuildingConstructionInProgressAvailable } from "./checks/checkBuildingConstructionInProgressAvailable";
import { checkBuildingNotProductionDoneState } from "./checks/checkBuildingNotProductionDoneState";
import { checkIsBuildingDecoration } from "./checks/checkIsBuildingDecoration";
import { pathFocusBuildingMaxLevelOfType } from "./paths/pathFocusBuildingMaxLevelOfType";
import { pathFocusStandardBuildingMaxLevel } from "./paths/pathFocusStandardBuildingMaxLevel";
import { pathSelectBuildingInBuildMenuHaveBuilding } from "./paths/pathSelectBuildingInBuildMenuHaveBuilding";
import { pathSelectBuildingMaxLevelExceptProductionDoneState } from "./paths/pathSelectBuildingMaxLevelExceptProductionDoneState";
export var epicShowMeHaveBuilding = function (action$, state$, deps) {
    // TODO: Could Naming be done based on shopCategory?
    var action1 = action$.pipe(ofType(TypeActionShowMe.QuestTaskHaveBuildings), guard(state$, deps, pathEmpty)([
        combineChecks([checkIsBuildingDecoration, checkAnyDecorationConstructionDoneAvailable])(pathFocusDecorationBuildingMaxLevel),
    ]));
    var action2 = action$.pipe(ofType(TypeActionShowMe.QuestTaskHaveBuildings), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkIsBuildingDecoration,
            invert(checkAnyDecorationConstructionDoneAvailable),
            checkAnyDecorationConstructionInProgressAvailable,
        ])(pathSelectBuildingConstructionInProgress),
    ]));
    var action3 = action$.pipe(ofType(TypeActionShowMe.QuestTaskHaveBuildings), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkIsBuildingDecoration,
            invert(checkAnyDecorationConstructionDoneAvailable),
            invert(checkAnyDecorationConstructionInProgressAvailable),
        ])(pathSelectDecorationTabInBuildMenu),
    ]));
    var action4 = action$.pipe(ofType(TypeActionShowMe.QuestTaskHaveBuildings), guard(state$, deps, pathEmpty)([
        combineChecks([
            invert(checkIsBuildingDecoration),
            invert(checkBuildingAvailableWithLessThanRequiredLevel),
            checkBuildingConstructionDoneAvailable,
        ])(pathFocusBuildingMaxLevelOfType),
    ]));
    var action5 = action$.pipe(ofType(TypeActionShowMe.QuestTaskHaveBuildings), guard(state$, deps, pathEmpty)([
        combineChecks([
            invert(checkIsBuildingDecoration),
            invert(checkBuildingAvailableWithLessThanRequiredLevel),
            invert(checkBuildingConstructionDoneAvailable),
            checkBuildingConstructionInProgressAvailable,
        ])(pathSelectBuildingConstructionInProgress),
    ]));
    var action6 = action$.pipe(ofType(TypeActionShowMe.QuestTaskHaveBuildings), guard(state$, deps, pathEmpty)([
        combineChecks([
            invert(checkIsBuildingDecoration),
            invert(checkBuildingAvailableWithLessThanRequiredLevel),
            invert(checkBuildingConstructionDoneAvailable),
            invert(checkBuildingConstructionInProgressAvailable),
        ])(pathSelectBuildingInBuildMenuHaveBuilding),
    ]));
    var action7 = action$.pipe(ofType(TypeActionShowMe.QuestTaskHaveBuildings), guard(state$, deps, pathEmpty)([
        combineChecks([
            invert(checkIsBuildingDecoration),
            checkBuildingAvailableWithLessThanRequiredLevel,
            checkBuildingConstructionDoneAvailable,
        ])(pathFocusStandardBuildingMaxLevel),
    ]));
    var action8 = action$.pipe(ofType(TypeActionShowMe.QuestTaskHaveBuildings), guard(state$, deps, pathEmpty)([
        combineChecks([
            invert(checkIsBuildingDecoration),
            checkBuildingAvailableWithLessThanRequiredLevel,
            invert(checkBuildingConstructionDoneAvailable),
            checkBuildingNotProductionDoneState,
        ])(pathSelectBuildingMaxLevelExceptProductionDoneState),
    ]));
    var action9 = action$.pipe(ofType(TypeActionShowMe.QuestTaskHaveBuildings), guard(state$, deps, pathEmpty)([
        combineChecks([
            invert(checkIsBuildingDecoration),
            checkBuildingAvailableWithLessThanRequiredLevel,
            invert(checkBuildingConstructionDoneAvailable),
            invert(checkBuildingNotProductionDoneState),
        ])(pathFocusBuildingMaxLevelOfType),
    ]));
    return merge(action1, action2, action3, action4, action5, action6, action7, action8, action9);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-building/epicShowMeHaveBuilding.ts
// module id = 2366
// module chunks = 3